import { connect } from 'react-redux';
import InvoicesView from './invoiceTemplate-view';
import { saveInvoiceTemplate, getInvoiceTemplate, aiEditTemplate, saveInvoiceTemplateAsNew } from '../../reducers/invoiceTemplate';

const mapStateToProps = state => {
    return {
        invoiceTemplate: state.invoiceTemplates.invoiceTemplate,
        company: state.companies.company,
        loading: state.invoiceTemplates.loading,
        user: state.auth.user,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        saveInvoiceTemplate: (template) => {
            dispatch(saveInvoiceTemplate(template));
        },
        getInvoiceTemplate: (id) => {
            dispatch(getInvoiceTemplate(id));
        },
        aiEditTemplate: (payload) => {
            return dispatch(aiEditTemplate(payload));
        },
        saveInvoiceTemplateAsNew: (template, name) => {
            return dispatch(saveInvoiceTemplateAsNew(template, name));
        },
    };
};

const header = connect(mapStateToProps, mapDispatchToProps)(InvoicesView);

export default header;
